<div class="mat-container" [class.full-width]="fullWidth"><ng-content></ng-content></div>
